import { ListData } from "../../app/store/reducers/appSlice"

export const prepareFilterQuery = (filter?: any) => {
  const values = {
    ...filter,
    category: getIdsFromDropdownValue(filter?.category),
    activity: Array.isArray(filter?.activity) ? filter.activity :
        (filter?.activity ? [filter.activity] : [])
  }

  const query: any = {}
  query.nameFull = values.global ? [{"operator": "%like%", "value": values.global}] : undefined
  query.country_id = values.country ? [{"operator": "=", "value": values.country}] : undefined
  query.stend = values.stend ? [{"operator": "%like%", "value": values.stend}] : undefined
  query.categoryId = values.category ? [{"operator": "in", "value": values.category}] : undefined
  query.activityId = values.activity && values.activity.length > 0 ?
      [{ "operator": "in", "value": values.activity }] : undefined
  query.seo = values.seo ? [{ "operator": "%like%", "value": values.seo }] : undefined

  if (values.productionType) {
    switch (values.productionType) {
      case 'shipTech':
        query.st = [{ "operator": "=", "value": true }];
        break;
      case 'aquafarm':
        query.af = [{ "operator": "=", "value": true }];
        break;
      case 'all':
      default:
        break;
    }
  }

  return {
    filter: query
  }
}

export const getIdsFromDropdownValue = (value?: Array<ListData>) => {
  if (value && value.length) {
    return value.map(item => item.value)
  }
}
